import { StringHelper } from '@bryntum/schedulerpro';
/**
 * Sanitizes a string by escaping potentially harmful characters.
 * @param {string} input - The string to be sanitized.
 * @return {string} - The sanitized string.
 */
export function escapeCharacters(input: string | undefined): string {
  return StringHelper.xss`${input}`;
}
